<template>
  <div>
    <section>
      <div class="header">
        <router-link to="/">
          <img
            src="/img/HPMainLogo-creators-min.png"
            class="helixpay-main-logo"
            alt="HelixPay"
          />
        </router-link>
      </div>

      <div class="info">
        <img src="img/congrats-mobile.svg" alt="Avatar" />
        <h4>
          You are one step closer to launching your store and earning up to
          <strong>₱1,000,000</strong>+ per month
        </h4>
        <p>Like our current partner creators!</p>
        <div class="creators-images">
          <img src="img/nuggets-min.jpg" alt="Avatar" class="image" />
          <img src="img/spart-min.jpg" alt="Avatar" class="image" />
          <img src="img/poortraveler.png" alt="Avatar" class="image" />
          <img src="img/adamalejo-min.jpg" alt="Avatar" class="image" />
          <img src="/img/aryn-min.jpg" alt="Avatar" class="image" />
          <img src="img/kumu-icon.png" alt="Avatar" class="image" />
          <img src="img/tierone.svg" alt="Avatar" class="image" />
          <img src="img/awkp-min.jpg" alt="Avatar" class="image" />
          <img src="img/raux-min.jpg" alt="Avatar" class="image" />
          <img src="img/tioco.jpg" alt="Avatar" class="image" />
        </div>
      </div>

      <h1 class="find-out">Learn how creators are earning with HelixPay!</h1>
    </section>
  </div>
</template>

<style scoped>
section {
  width: 100%;
  padding: 2rem;
  background-color: black;
}

.header {
  max-width: 60rem;
  margin: auto;
}

.header img {
  width: 10rem;
}

.info {
  max-width: 60rem;
  margin: auto;
  text-align: center;
  padding: 3rem 0;
}

.info > img {
  max-width: 45rem;
  margin: 2rem auto;
  pointer-events: none;
}

.info h4 {
  width: 70%;
  margin: auto;
  font-size: 1.5rem;
  font-weight: 500;
  color: white;
  margin-top: 2rem;
}

.info p {
  font-size: 1rem;
  font-weight: 600;
  margin: 1.5rem 0;
  color: white;
  margin-top: 2rem;
  opacity: 0.5;
}

.creators-images {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 1rem;
}

.creators-images img {
  width: 100%;
  border-radius: 5px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.3);
}

.find-out {
  max-width: 60rem;
  margin: auto;
  margin-top: 5rem;
  margin-bottom: -3rem;
  font-size: 2rem;
  font-weight: 700;
  color: #ff5f8f;
  text-align: center;
}

@media only screen and (max-width: 800px) {
  .info h4 {
    font-size: 1rem;
  }

  .find-out {
    font-size: 1.5rem;
  }
}
</style>
